import { render, staticRenderFns } from "./ContinuousAquariusDetails.vue?vue&type=template&id=06e7a6e9"
import script from "./ContinuousAquariusDetails.vue?vue&type=script&lang=js"
export * from "./ContinuousAquariusDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports